"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const axios_1 = __importDefault(require("axios"));
const vue_multiselect_1 = __importDefault(require("vue-multiselect"));
const vue_property_decorator_1 = require("vue-property-decorator");
let Avanzado = class Avanzado extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.operacionId = 0;
        this.barrios = [];
        this.ciudades = [];
        this.barriosLoading = true;
        this.tipos = [];
        this.tipoId = 0;
        this.tiposLoading = true;
        this.mapa = false;
        this.ambientes = 0;
        this.precio = [0, 0];
        this.precios = { min: 0, max: 0, moneda: "" };
        this.precioLoading = true;
    }
    created() {
        let operacion = lodash_1.default.head(this.operaciones);
        if (operacion) {
            this.operacionId = operacion.id;
        }
        this.getTipos();
        this.getPrecios();
        this.getBarrios();
    }
    getTipos() {
        this.tipoId = 0;
        this.tiposLoading = true;
        axios_1.default
            .get("/api/tipos", {
            params: { operacion: this.operacionId },
        })
            .then((result) => {
            let tipos = [];
            tipos.push({
                id: 0,
                slug: "",
                nombre: "Todos",
            });
            result.data.forEach((tipo) => {
                tipos.push(tipo);
            });
            this.tipos = tipos;
            this.tiposLoading = false;
        })
            .catch((error) => {
            this.$bvToast.toast(error, {
                title: `Error`,
                variant: `danger`,
                solid: true,
            });
        });
    }
    getBarrios() {
        this.barrios = [];
        this.barriosLoading = true;
        axios_1.default
            .get("/api/barrios", {
            params: {
                tipo: this.tipoId,
                operacion: this.operacionId,
            },
        })
            .then((result) => {
            this.ciudades = result.data;
            this.barriosLoading = false;
        })
            .catch((error) => {
            this.$bvToast.toast(error, {
                title: `Error`,
                variant: `danger`,
                solid: true,
            });
        });
    }
    getPrecios() {
        this.precioLoading = true;
        axios_1.default
            .get("/api/precios", {
            params: {
                tipo: this.tipoId,
                operacion: this.operacionId,
            },
        })
            .then((result) => {
            this.precios = result.data;
            this.precio = [this.precios.min, this.precios.max];
            this.precioLoading = false;
        })
            .catch((error) => {
            this.$bvToast.toast(error, {
                title: `Error`,
                variant: `danger`,
                solid: true,
            });
        });
    }
    onTipoChanged() {
        if (this.barriosLoading === false) {
            this.getBarrios();
        }
        if (this.precioLoading === false) {
            this.getPrecios();
        }
    }
    onOperacionChanged() {
        if (this.tiposLoading === false) {
            this.getTipos();
        }
        if (this.barriosLoading === false) {
            this.getBarrios();
        }
        if (this.precioLoading === false) {
            this.getPrecios();
        }
    }
    get precioPlaceholder() {
        let min = this.precio[0].toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        });
        let max = this.precio[1].toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        });
        return `${min} - ${max}`;
    }
    get action() {
        let uri = [];
        if (this.tipoId) {
            const tipo = lodash_1.default.find(this.tipos, ["id", this.tipoId]);
            if (tipo) {
                uri.push(tipo.slug);
            }
        }
        if (this.operacionId) {
            const operacion = lodash_1.default.find(this.operaciones, ["id", this.operacionId]);
            if (operacion) {
                if (this.tipoId) {
                    uri.push("para");
                }
                uri.push(operacion.slug);
            }
        }
        let barrios = [];
        if (this.barrios.length === 1) {
            uri.push("en");
            uri.push(this.barrios[0].slug);
        }
        return uri.join("-");
    }
    setAmbientes(n) {
        if (this.ambientes === n) {
            this.ambientes = 0;
        }
        else {
            this.ambientes = n;
        }
    }
    setOperacion(id) {
        this.operacionId = id;
    }
    formatear(valor) {
        return valor.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        });
    }
    get btnDisabled() {
        return this.tiposLoading || this.precioLoading || this.barriosLoading;
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean }),
    __metadata("design:type", Boolean)
], Avanzado.prototype, "filtrosAvanzados", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Array, required: true }),
    __metadata("design:type", Array)
], Avanzado.prototype, "operaciones", void 0);
__decorate([
    vue_property_decorator_1.Watch("tipoId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Avanzado.prototype, "onTipoChanged", null);
__decorate([
    vue_property_decorator_1.Watch("operacionId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Avanzado.prototype, "onOperacionChanged", null);
Avanzado = __decorate([
    vue_property_decorator_1.Component({ components: { Multiselect: vue_multiselect_1.default } })
], Avanzado);
exports.default = Avanzado;
